import { useCallback } from 'react';
import PropTypes from 'prop-types';
import * as constants from './../../constants';
import { useDispatch, useSelector } from 'react-redux';
import { FaArrowRight, FaStream, FaUsers } from 'react-icons/fa';
import { openDrawer } from '../../features/drawersSlice';
import {
    setMobileSearchOptions,
    setOpenFilters,
    setMobileDetailsOpen,
} from 'features/multiproperty/MultipropertySlice';
import { formatDate } from 'lib';
import { dateFormatMobileStr } from './../../constants';
import { setCalendarOpen } from 'features/userSlice';

const MobileHeaderOptions = ({ propertyType }) => {
    const dispatch = useDispatch();
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const isMobileFiltersOpen = useSelector(
        (state) => state.multiproperty?.isMobileFiltersOpen
    );
    const isMobileSearchOptionsOpen = useSelector(
        (state) => state.multiproperty?.isMobileSearchOptionsOpen
    );
    const isMobileDetailsOpen = useSelector(
        (state) => state.multiproperty?.isMobileDetailsOpen
    );

    const adults = useSelector((state) => state.user?.adults);

    const isOpen = useSelector((state) => state.user?.isCalendarOpen);
    const setIsOpen = (isOpen) => {
        dispatch(setCalendarOpen({ isCalendarOpen: isOpen }));
    };
    const userCountryCode =
        useSelector((state) => state.user?.language) || 'en-US';
    const tempCheckInDate = useSelector(
        (state) => state.user?.checkInDay?.date
    );
    const tempCheckOutDate = useSelector(
        (state) => state.user?.checkOutDay?.date
    );

    const showMap = useCallback(() => {
        dispatch(openDrawer({ drawerId: 'MapDrawer' }));
    }, []);

    // const showPropertySidebar = useCallback(() => {
    //     dispatch(openDrawer({ drawerId: 'PropertySidebarDrawer' }));
    // }, []);

    const selectedPropertyId = useSelector(
        (state) => state.multiproperty?.selectedPropertyId
    );

    return (
        <div className="ab-inner-header">
            <div className="ab-multi-filters">
                {propertyType === constants.SINGLE_PROPRETY ||
                !!selectedPropertyId ? (
                    <div
                        className="ab-filter"
                        // onClick={showPropertySidebar}
                        onClick={() =>
                            dispatch(
                                setMobileDetailsOpen({
                                    isMobileDetailsOpen: !isMobileDetailsOpen,
                                })
                            )
                        }
                    >
                        {Lang?.details}
                    </div>
                ) : (
                    <div className="ab-filter" onClick={showMap}>
                        {Lang?.map}
                    </div>
                )}

                <div
                    className="ab-filter"
                    style={{ minWidth: '100px' }}
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {tempCheckInDate && tempCheckOutDate ? (
                        <>
                            <span className="ab-value">
                                {formatDate(
                                    new Date(tempCheckInDate),
                                    dateFormatMobileStr,
                                    userCountryCode
                                )}
                            </span>
                            <span>
                                <FaArrowRight size={10} />
                            </span>
                            <span className="ab-value">
                                {formatDate(
                                    new Date(tempCheckOutDate),
                                    dateFormatMobileStr,
                                    userCountryCode
                                )}
                            </span>
                        </>
                    ) : (
                        <span className="ab-value">—</span>
                    )}
                </div>

                <div
                    className="ab-filter"
                    style={{ maxWidth: '55px' }}
                    onClick={() =>
                        dispatch(
                            setMobileSearchOptions({
                                isMobileSearchOptionsOpen:
                                    !isMobileSearchOptionsOpen,
                            })
                        )
                    }
                >
                    <i
                        className="fa fa-users"
                        style={{
                            paddingRight: '5px',
                        }}
                    ></i>
                    <FaUsers />{' '}
                    <span style={{ paddingLeft: '5px' }}>{adults}</span>
                </div>
                <div
                    className="ab-filter"
                    style={{ minWidth: '85px' }}
                    onClick={() =>
                        dispatch(
                            setOpenFilters({
                                isMobileFiltersOpen: !isMobileFiltersOpen,
                            })
                        )
                    }
                >
                    <FaStream />
                    <span style={{ paddingLeft: '10px' }}>{Lang?.filters}</span>
                </div>
            </div>
        </div>
    );
};

MobileHeaderOptions.propTypes = {
    propertyType: PropTypes.string,
};

export default MobileHeaderOptions;
